/**
 * @generated SignedSource<<1b31fecff05b2c93c9f6a46e337a94c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueCreateProvider$data = {
  readonly jira: {
    readonly rankField?: {
      readonly fieldId: string | null | undefined;
    } | null | undefined;
    readonly rankFieldOld?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldId: string;
        };
      }>;
    } | null | undefined;
  };
  readonly " $fragmentType": "IssueCreateProvider";
};
export type IssueCreateProvider$key = {
  readonly " $data"?: IssueCreateProvider$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreateProvider">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "fieldId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "IssueCreateProvider",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v0/*: any*/)
                ],
                "concreteType": "JiraJqlFieldWithAliases",
                "kind": "LinkedField",
                "name": "rankField",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "rankFieldOld",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "aliasFieldIds",
                        "value": [
                          "rank"
                        ]
                      },
                      (v0/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "JiraFieldConfigConnection",
                "kind": "LinkedField",
                "name": "jiraFieldConfigs",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraFieldConfigEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssueFieldConfig",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v1/*: any*/),
                                "action": "THROW",
                                "path": "jira.rankFieldOld.edges.node.fieldId"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.rankFieldOld.edges.node"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.rankFieldOld.edges"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "59e5faa8f2e50ce505588415c5a62b62";

export default node;
